import './SelectMultiTenantFilter.scss';
import Component from './SelectMultiTenantFilter.js';
export default Component;
